export default {
  required: "Feld wird benötigt",
  lessThan10: "Feld muss weniger als 10 Zeichen haben",
  lessThan100: "Feld muss weniger als 100 Zeichen haben",
  lessThan250: "Feld darf höchstens 250 Zeichen haben",
  lessThan256: "Feld muss weniger als 256 Zeichen haben",
  lessThan5000: "Feld muss weniger als 5000 Zeichen haben",
  moreThan3: "Feld muss mehr als 3 Zeichen haben",
  isHex: "Feld muss ein Hexadezimal Wert sein",
  isEmail: "Feld muss eine gültige Email-Adresse sein",
  isInteger: "Feld muss eine gültige Ganzzahl sein",
  atLeast1: "Mindestens einen Wert eintragen",
  noSpecialCharacters: "Keine Sonderzeichen erlaubt",
  onlyNumberWithDotsAndComma: "Feld muss eine Dezimalzahl sein",
  onlyNumberWithDotsAndCommaAndPrefixSign: "Feld muss positive oder negative Dezimalzahl sein",
  objectWithKey: "Feld wird benötigt",
  authentication: {
    validAuthentication: "Ungültige Anmeldedaten",
  },
}
